export default function cssVariable() {
  const { documentElement, body: bodyElement } = document;
  let prevWidth = null;
  let prevHeight = null;

  const resizeHandler = () => {
    const { clientWidth, clientHeight } = documentElement;

    if (clientWidth !== prevWidth) {
      bodyElement.style.setProperty('--jsClientWidth', `${clientWidth}px`);
      prevWidth = clientWidth;
    }
    if (clientHeight !== prevHeight) {
      bodyElement.style.setProperty('--jsClientHeight', `${clientHeight}px`);
      prevHeight = clientHeight;
    }
  };

  window.addEventListener('resize', resizeHandler);
  resizeHandler();

  const sizeVariableNodeList = document.querySelectorAll(
    '[data-width-variable], [data-height-variable]',
  );

  if (sizeVariableNodeList.length === 0) return;

  const resizeObserver = new ResizeObserver((entries) => {
    entries.forEach((entry) => {
      const targetElement = entry.target;

      if ('widthVariable' in targetElement.dataset) {
        const variableSetElement = (() => {
          try {
            return document.querySelector(targetElement.dataset.widthVariable);
          } catch (error) {
            return null;
          }
        })();

        (variableSetElement || variableSetElement).style.setProperty(
          '--jsContainerWidth',
          `${entry.contentRect.width}px`,
        );
      }
      if ('heightVariable' in targetElement.dataset) {
        const variableSetElement = (() => {
          try {
            return document.querySelector(targetElement.dataset.heightVariable);
          } catch (error) {
            return null;
          }
        })();

        (variableSetElement || targetElement).style.setProperty(
          '--jsContainerHeight',
          `${entry.contentRect.height}px`,
        );
      }
    });
  });
  sizeVariableNodeList.forEach((element) => {
    resizeObserver.observe(element);
  });
}
